import { Component, OnInit, Input } from '@angular/core';
import { Field } from '../../../../src/app/features/dynamic-form/dynamic-form.component';
import { Entry } from 'contentful';
import { ProfileService } from '../../services/profile/profile.service';
import { FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-settings-communication',
  templateUrl: './settings-communication.component.html',
  styleUrls: ['./settings-communication.component.scss'],
})
export class SettingsCommunicationComponent implements OnInit {
  @Input() public content: Entry<any> | undefined;
  public user = this.profileService.user();

  public newsletterField: Field = {
    type: 'checkbox',
    label: 'Send me the Compensate newsletter',
    key: 'newsletter',
  };

  public newsletterControl: FormControl;

  constructor(private profileService: ProfileService) {}

  newsletterChanged(subscribed: boolean): void {
    this.profileService.updateUserDocument({ newsletter: subscribed });
  }

  async ngOnInit(): Promise<void> {
    const { newsletter } = await this.user.pipe(first()).toPromise();
    this.newsletterControl = new FormControl(newsletter);
    this.newsletterControl.valueChanges.subscribe((subscribed) => {
      this.newsletterChanged(subscribed);
    });
  }
}
